<template>
  <div>
    <el-row :gutter="20">

      <el-col :span="4">
        <el-input placeholder="推广店铺名称" v-model="params.distributor" style="width: 100%" size="mini"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="推广人姓名" v-model="params.spread_name" style="width: 100%" size="mini"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="推广人账号" v-model="params.spread_mobile" style="width: 100%" size="mini"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="用户账号" v-model="params.user_mobile" style="width: 100%" size="mini"></el-input>
      </el-col>
        <el-col :span="4">

            <el-select size="small" v-model="params.spread_type" clearable placeholder="推广类型">
                <el-option v-for="item in spread_type" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
            </el-select>
        </el-col>
        <el-col :span="4">

            <el-select size="small" v-model="params.source_from" clearable placeholder="推广来源">
                <el-option v-for="item in source_from" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
            </el-select>
        </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="5">
        <el-input placeholder="用户姓名" v-model="params.user_name" style="width: 100%" size="mini"></el-input>
      </el-col>
      <el-col :span="5">
            <el-input placeholder="商品id" v-model="params.item_id" style="width: 100%" size="mini"></el-input>
      </el-col>

      <el-col :md="10" :lg="8">
          <el-date-picker v-model="upload_at" type="daterange" start-placeholder="点击时间" ange-separator="至" end-placeholder="点击时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="updateDateChange" size="mini"></el-date-picker>
      </el-col>
      <el-col :span="3">
        <el-button type="primary" icon="plus"  style="width: 50%" size="mini" @click="searchData">搜索</el-button>
      </el-col>

    </el-row>
      <el-row >
          <el-col :span="4">
              <el-button type="primary" icon="plus"  style="width: 50%" size="mini" @click="exportData">导出数据</el-button>
          </el-col>
      </el-row>

   <el-table :data="data" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="spread_user_id" label="推广人id" width="100"></el-table-column>
      <el-table-column prop="distributor" label="店铺" width="150"></el-table-column>
      <el-table-column prop="created_at" label="用户点击时间" width="150">
          <template slot-scope="scope">{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
      </el-table-column>
      <el-table-column prop="spread_name" label="推广人姓名" width="100"></el-table-column>
      <el-table-column prop="spread_mobile" label="推广人账号" width="130"></el-table-column>
      <el-table-column prop="user_name" label="用户姓名" width="100"></el-table-column>
      <el-table-column prop="user_mobile" label="用户账号" width="150"></el-table-column>
       <el-table-column prop="spread_type" label="推广类型" width="100">
           <template slot-scope="scope">
               <el-tag size="mini" effect="plain"  v-if="scope.row.spread_type=='distributor'">店铺</el-tag>
               <el-tag size="mini" effect="plain"  v-else-if="scope.row.spread_type=='distri_good'">店铺商品</el-tag>
               <el-tag size="mini" effect="plain"  v-else-if="scope.row.spread_type=='custom'">自定义</el-tag>
               <el-tag size="mini" effect="plain"  v-else-if="scope.row.spread_type=='goods'">商品</el-tag>
               <el-tag size="mini" effect="plain"  v-else >其他</el-tag>
           </template>
       </el-table-column>
       <el-table-column prop="source_from" label="推广来源" width="80">
           <template slot-scope="scope">
               <el-tag size="mini" effect="plain"  v-if="scope.row.source_from=='android'">android</el-tag>
               <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='ios'">ios</el-tag>
               <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='wxapp'">多店铺小程序</el-tag>
               <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='youxuanwxapp'">优选小程序</el-tag>
               <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='aliapp'">支付宝小程序</el-tag>
               <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='h5'">H5</el-tag>
               <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='pc'">Pc</el-tag>
               <el-tag size="mini" effect="plain"  v-else >其他</el-tag>
           </template>
       </el-table-column>
       <el-table-column prop="item_id" label="商品id" width="100"></el-table-column>
    </el-table>
   <div v-if="total_count > params.pageSize" class="content-padded content-center">
       <el-pagination
               background
               layout="prev, pager, next"
               @current-change="handleCurrentChange"
               :current-page.sync="params.page"
               :total="total_count" :page-size="params.pageSize">
       </el-pagination>
   </div>
  </div>
</template><script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getDistributorLogsList,exportData} from '@/api/spread'
  export default {
    data () {
      return {
        data: [],
        upload_at:'',
        loading: false,
          spread_type:[{name:'分享店铺',value:'distributor'},
              {name:'分享店铺商品',value:'distri_good'},
              {name:'自定义',value:'custom'},
              {name:'商品',value:'goods'}],

          source_from:[{name:'Android',value:'android'},
              {name:'IOS',value:'ios'},
              {name:'多店铺小程序',value:'wxapp'},
              {name:'优选小程序',value:'youxuanwxapp'},
              {name:'支付宝小程序',value:'aliapp'},
              {name:'H5',value:'h5'},
              {name:'PC',value:'pc'}],
        total_count: 0,
        params: {
          page: 1,
          pageSize: 20,
        }
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },

      getDataList () {
        this.loading = true
        getDistributorLogsList(this.params).then(response => {

          this.data = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        })
      },
      searchData () {
        this.getDataList()
      },
      typesearch (){
          this.getDataList()
      },
      updateDateChange (val) {
          if (val && val.length > 0) {
              this.params.start_upload_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
              this.params.end_upload_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
          } else {
              this.params.start_upload_at = ''
              this.params.end_upload_at = ''
          }
          console.log(this.params)
          this.getDataList();
      },
      dateStrToTimeStamp (str) {
          return Date.parse(new Date(str))/1000
      },
      exportData(){
          exportData(this.params).then(response => {
              if(response.data) {
                  var a = document.createElement('a')
                  a.href = response.data.url
                  a.download = response.data.filename
                  a.click()
              }
          })
      }
    },
    mounted () {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// logs.vue?60d85ba9